import { render } from "./createsalesreturn.vue?vue&type=template&id=10a4cc40"
import script from "./createsalesreturn.vue?vue&type=script&lang=js"
export * from "./createsalesreturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__